import React, { useCallback, useEffect, useState } from "react";
import { Search } from "lucide-react";
import { qrtListFlows } from "../../apis/qrtAdmin";
import { Pager, Spinner, StatusChip, fmtDateTime } from "./qrtUi";
import { ScopedPage } from "./QrtScopedPage";

const PAGE_SIZE = 25;

const FlowsTable = ({ userId }) => {
  const [data, setData] = useState({ rows: [], total: 0 });
  const [search, setSearch] = useState("");
  const [active, setActive] = useState("");
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await qrtListFlows({
        user_id: userId, limit: PAGE_SIZE, offset: page * PAGE_SIZE,
        ...(search ? { search } : {}),
        ...(active !== "" ? { active } : {}),
      });
      setData(res.data?.data || { rows: [], total: 0 });
    } catch (_) {}
    finally { setLoading(false); }
  }, [userId, search, active, page]);

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [load]);

  useEffect(() => { setPage(0); }, [userId]);

  return (
    <div className="qrt-card">
      <div className="qrt-card-head">
        <Search size={15} style={{ color: "var(--text-3)" }} />
        <input type="search" placeholder="Search flow name…" value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(0); }}
          style={{ flex: 1, border: "none", outline: "none" }} />
        <select value={active} onChange={(e) => { setActive(e.target.value); setPage(0); }}>
          <option value="">All</option>
          <option value="1">Active</option>
          <option value="0">Inactive</option>
        </select>
      </div>
      {loading ? <Spinner /> : (
        <table className="qrt-table">
          <thead>
            <tr>
              <th>Flow</th>
              <th>Trigger</th>
              <th>State</th>
              <th className="r">Updated</th>
              <th className="r">Created</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((f) => (
              <tr key={f.id}>
                <td>
                  <div style={{ fontWeight: 600 }}>{f.name}</div>
                  <div className="sub">#{f.id}</div>
                </td>
                <td className="mono">{f.trigger_type || "—"}</td>
                <td><StatusChip value={f.is_active ? "active" : "paused"} /></td>
                <td className="r sub">{fmtDateTime(f.updated_at)}</td>
                <td className="r sub">{fmtDateTime(f.created_at)}</td>
              </tr>
            ))}
            {data.rows.length === 0 && (
              <tr><td className="empty" colSpan={5}>No flows for this user</td></tr>
            )}
          </tbody>
        </table>
      )}
      <Pager page={page} total={data.total} pageSize={PAGE_SIZE} onPage={setPage} />
    </div>
  );
};

const QrtFlows = () => (
  <ScopedPage title="Chatbot flows" noun="flows">
    {(userId) => <FlowsTable userId={userId} />}
  </ScopedPage>
);

export default QrtFlows;
